import { UserModel } from "../../../shared/model/userModel";
import { Observable } from "rxjs/Observable";

export abstract class AbstractResetAccountService {
  abstract resetAccount(user: UserModel): Observable<any>;
}


// WEBPACK FOOTER //
// ./src/app/account/resetAccount/services/abstract-resetAcountService.ts